import React from 'react';
import Css from './About.module.css';

export default function About() {
    return <div id='About' className={Css.container}>

        <span>
            <img className={Css.Image} src="https://i.ibb.co/Wz0dqZS/codder.png" alt="Shweta" />
        </span>

        <span className={Css.infoContainer}>
            <h1 className={Css.heading}> Hello &#128075;</h1>
            <p className={Css.info}>
                My name is Shweta and I am a Full Stack (MERN) developer. I am from Kaithal, Haryana. I completed my BCA in 2021. I have great interest in coding. I enjoy building small site to rich intreactive web apps. If you are an employer looking to hire, you can get in touch with me.
            </p>
        </span>
    </div>;
}
